import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Merge class names: clsx (conditional joining) + tailwind-merge (dedupe
 * conflicting Tailwind utilities). Single source of truth — this was copied
 * byte-for-byte into ~10 apps' lib/cn.ts / lib/utils.ts; those now re-export it.
 *
 * Imported via the `@gjl/lib/cn` subpath so consumers pull only clsx +
 * tailwind-merge, not the rest of @gjl/lib.
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
